import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: absolute;
  left: 30px;
  top: 250px;
  width: 280px;
  background-color: rgba(30, 30, 60, 0.8);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: inset 0px 0px 30px 2px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.2);
`;
